import type { Template } from "@/types";

export const PO_07_H5_V2: Template[] = [
    {
        id: "po-07-h5v2-01",
        name: "PO 01 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_01.png",
        size: [1298, 827],
        style: {},
        slots: [               
            { id: "1", x: 45, y: 152, width: 262, height: 170, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 330, width: 262, height: 169, rotation: 0, imageRotation: 0 },
            { id: "3", x: 45, y: 507, width: 262, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 315, y: 152, width: 287, height: 524, rotation: 0, imageRotation: 0 },
            { id: "5", x: 713, y: 232, width: 250, height: 177, rotation: 0, imageRotation: 0 },
            { id: "6", x: 713, y: 417, width: 250, height: 177, rotation: 0, imageRotation: 0 },
            { id: "7", x: 971, y: 232, width: 250, height: 362, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h5v2-02",
        name: "PO 02 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 73, y: 166, width: 503, height: 320, rotation: 0, imageRotation: 0 },
            { id: "2", x: 73, y: 494, width: 115, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 196, y: 494, width: 258, height: 167, rotation: 0, imageRotation: 0 },
            { id: "4", x: 462, y: 494, width: 114, height: 167, rotation: 0, imageRotation: 0 },
            { id: "5", x: 723, y: 166, width: 503, height: 327, rotation: 0, imageRotation: 0 },
            { id: "6", x: 723, y: 501, width: 248, height: 159, rotation: 0, imageRotation: 0 },
            { id: "7", x: 979, y: 501, width: 247, height: 159, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-03",
        name: "PO 03 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 43, y: 166, width: 248, height: 160, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 334, width: 248, height: 159, rotation: 0, imageRotation: 0 },
            { id: "3", x: 43, y: 501, width: 248, height: 159, rotation: 0, imageRotation: 0 },
            { id: "4", x: 299, y: 166, width: 312, height: 494, rotation: 0, imageRotation: 0 },
            { id: "5", x: 714, y: 166, width: 516, height: 252, rotation: 0, imageRotation: 0 },
            { id: "6", x: 714, y: 426, width: 342, height: 233, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1064, y: 426, width: 167, height: 233, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-04",
        name: "PO 04 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 226, width: 553, height: 375, rotation: 0, imageRotation: 0 },
            { id: "2", x: 561, y: 226, width: 141, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 710, y: 226, width: 290, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1008, y: 226, width: 290, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 561, y: 417, width: 290, height: 184, rotation: 0, imageRotation: 0 },
            { id: "6", x: 859, y: 417, width: 290, height: 184, rotation: 0, imageRotation: 0 },        
            { id: "7", x: 1157, y: 417, width: 141, height: 184, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h5v2-05",
        name: "PO 05 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 49, y: 227, width: 338, height: 220, rotation: 0, imageRotation: 0 },
            { id: "2", x: 395, y: 227, width: 338, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 49, y: 455, width: 223, height: 145, rotation: 0, imageRotation: 0 },
            { id: "4", x: 280, y: 455, width: 223, height: 145, rotation: 0, imageRotation: 0 },
            { id: "5", x: 511, y: 455, width: 222, height: 145, rotation: 0, imageRotation: 0 },
            { id: "6", x: 741, y: 227, width: 250, height: 372, rotation: 0, imageRotation: 0 },
            { id: "7", x: 999, y: 227, width: 249, height: 372, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-06",
        name: "PO 06 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 53, y: 516, width: 292, height: 188, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 653, y: 123, width: 292, height: 385, rotation: 0, imageRotation: 0 },
            { id: "3", x: 953, y: 123, width: 292, height: 385, rotation: 0, imageRotation: 0 },
            { id: "4", x: 53, y: 123, width: 592, height: 385, rotation: 0, imageRotation: 0 },
            { id: "5", x: 353, y: 516, width: 292, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 653, y: 516, width: 292, height: 188, rotation: 0, imageRotation: 0 },
            { id: "7", x: 953, y: 516, width: 292, height: 188, rotation: 0, imageRotation: 0 }
           
        ],
    },

    {
        id: "po-07-h5v2-07",
        name: "PO 07 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 171, width: 227, height: 156, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 335, width: 227, height: 156, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 499, width: 227, height: 156, rotation: 0, imageRotation: 0 },
            { id: "4", x: 235, y: 171, width: 365, height: 484, rotation: 0, imageRotation: 0 },
            { id: "5", x: 608, y: 171, width: 365, height: 484, rotation: 0, imageRotation: 0 },
            { id: "6", x: 981, y: 171, width: 317, height: 238, rotation: 0, imageRotation: 0 },
            { id: "7", x: 981, y: 417, width: 317, height: 238, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-08",
        name: "PO 08 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_08.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 0, y: 171, width: 227, height: 156, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 335, width: 227, height: 156, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 499, width: 227, height: 156, rotation: 0, imageRotation: 0 },
            { id: "4", x: 235, y: 171, width: 366, height: 484, rotation: 0, imageRotation: 0 },
            { id: "5", x: 934, y: 171, width: 364, height: 484, rotation: 0, imageRotation: 0 },
            { id: "6", x: 609, y: 171, width: 317, height: 238, rotation: 0, imageRotation: 0 },
            { id: "7", x: 609, y: 417, width: 317, height: 238, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-09",
        name: "PO 09 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 250, y: 149, width: 801, height: 529, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 149, width: 189, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 53, y: 284, width: 189, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 53, y: 418, width: 189, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 53, y: 552, width: 189, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1059, y: 149, width: 187, height: 261, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1059, y: 418, width: 187, height: 260, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-10",
        name: "PO 10 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 53, y: 149, width: 801, height: 529, rotation: 0, imageRotation: 0 },
            { id: "2", x: 862, y: 149, width: 188, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 862, y: 284, width: 188, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 862, y: 418, width: 188, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 862, y: 552, width: 188, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1058, y: 149, width: 188, height: 261, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1058, y: 418, width: 188, height: 260, rotation: 0, imageRotation: 0 }
        ],
    }
];